import React from "react";
import * as Mui from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./styles.scss";

export default function Preview({ image, onClose }) {
    return (
        <div className="preview-area">
            <img src={image} className="preview-img" alt="Preview" />
            <div className="overlay-close" onClick={onClose}></div>
            <Mui.IconButton onClick={onClose} className="close-icon">
                <CloseIcon color="white" />
            </Mui.IconButton>
        </div>
    );
}
